import { PriceDto } from '@/services/types/pricing.type';

interface PricingOptionProps {
  price: PriceDto;
  showDivider?: boolean;
}

export function PricingOption({ price, showDivider }: PricingOptionProps) {
  return (
    <>
      <div className="desktop:px-2 flex items-center justify-between py-5">
        {/* 라벨 + 설명 */}
        <div className="flex items-start justify-center">
          <p className="text-level-2 typo-20 desktop:typo-24 font-extrabold">
            {price.label}
          </p>
          {/* <p className="text-level-4 typo-16 desktop:typo-18 desktop:font-medium mt-2 font-semibold">
            {price.subLabel}
          </p> */}
        </div>

        {/* 가격 정보 */}
        <div className="desktop:gap-1.5 flex items-center justify-end gap-1">
          {/* 원가 */}
          <span className="text-level-6 typo-14 desktop:font-semibold font-medium line-through">
            {price.originPrice.toLocaleString()}원
          </span>
          <span className="text-main-orange typo-20 desktop:typo-24 font-extrabold">
            {price.price.toLocaleString()}원
          </span>
        </div>
      </div>
      {showDivider && <div className="bg-stroke-white h-px w-full" />}
    </>
  );
}
